import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FeedbackService from '../../api/feedback-service'
import { showToast } from '../../utils/toast'
import { handleErrorResponse } from '../../utils/handleErrorResponse'

const AddFeedback = ({ onBack }: { onBack?: () => void }) => {
  const navigate = useNavigate()
  const [rating, setRating] = useState(0)
  const [hoveredRating, setHoveredRating] = useState(0)
  const [comment, setComment] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (isSubmitting) return

    if (!comment.trim()) {
      showToast({ title: 'Error', description: 'Please enter your feedback comment', status: 'error' })
      return
    }

    if (rating === 0) {
      showToast({ title: 'Error', description: 'Please select a rating', status: 'error' })
      return
    }

    setIsSubmitting(true)
    try {
      await FeedbackService.submitFeedback({
        content: comment,
        rating: rating
      })
      showToast({ title: 'Success', description: 'Feedback submitted successfully!', status: 'success' })
      if (onBack) {
        onBack()
      } else {
        navigate('/feedback')
      }
    } catch (err) {
      handleErrorResponse(err, 'feedback-submit')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="p-6">
      <div className="mb-10 flex gap-6">
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-100 text-gray-700"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18l-6-6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
         <div className="text-lg text-gray-700 font-medium">Feedback</div>
        </button>
       <div className="ml-3 px-3 py-2 rounded-md bg-black text-white text-lg font-medium">
              {/* {showAdd ? 'Add Artisan' : displayName} */}
              Add Feedback
            </div>
      </div>

      {/* Feedback Form */}
          {/* Comment Input */}
          <div className="mb-8">
            {/* <label className="block text-sm font-medium text-gray-700 mb-2">
              Leave a comment
            </label> */}
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Leave a comment"
              className="w-full h-32 px-4 py-3 border border-gray-300 rounded-lg outline-none resize-y text-base"
            />
          </div>

          {/* Rating */}
          <div>
            <label className="block text-base font-semibold text-gray-700 mb-3">
              Rate
            </label>
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  className="transition-transform hover:scale-110 focus:outline-none"
                >
                  <svg
                    className={`w-8 h-8 ${
                      star <= (hoveredRating || rating)
                        ? 'text-orange-400 fill-current'
                        : 'text-gray-900'
                    }`}
                    stroke="currentColor"
                    fill={star <= (hoveredRating || rating) ? 'currentColor' : 'none'}
                    strokeWidth="1"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    />
                  </svg>
                </button>
              ))}
            </div>
          </div>

          {/* Done Button - Mobile/Bottom */}
          <div className="mt-8 flex justify-end">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="px-8 py-2.5 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors"
            >
              {isSubmitting ? 'Submitting...' : 'Done'}
            </button>
          </div>
    </div>
  )
}

export default AddFeedback
